<template>
	<div class="list">
		<div class="list-l" @click="toDetail" v-if="item.postType==1&&item.picUrl">
			<img :src="item.picUrl" />
		</div>
		<div class="list-l" @click="toDetail" v-if="(item.postType==2 || item.postType==0)&&item.coverUrl">
			<img :src="item.coverUrl" />
		</div>
		<!-- <div class="list-l" @click="toDetail" v-if="item.picUrl">
			<img :src="item.picUrl" />
		</div> -->
		<div class="list-m" @click="toDetail">
				<h3 class="list-title line1" v-if="item.postName||item.content">{{item.postName||item.content}}</h3>
			<div class="list-tips text-opacity">
				<span>{{item.addTime | datefmt('yyyy-MM-DD HH:mm:ss')}}</span>
			</div>
			<div class="list-btns">
				<a class="passed" href="javascript:;" v-if="item.auditStatus==1&&item.postStatus==1">已通过</a>
				<a class="no-pass" href="javascript:;" v-if="item.auditStatus==2&&item.postStatus==1">审核未通过</a>
				<a class="passing" href="javascript:;"  v-if="item.auditStatus==0&&item.postStatus==1">审核中</a>
				<span  v-if="item.postStatus==0">草稿</span>
			</div>
		</div>
		<div class="list-r">
			<div class="delete-btn" @click="toModify" v-if="item.postStatus==0">
				<i class="el-icon-edit"></i>
				<span> 修改</span>
			</div>
			<div class="delete-btn" @click="toDelete">
				<i class="el-icon-delete"></i>
				<span> 删除</span>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'publicItem',
		components: {},
		data() {
			return {

			}
		},
		props: {
			isAsync: {
				type: Boolean,
				value: false
			},
			item: {
				type: Object,
				value: ''
			},
			activeTab: {
				type: String,
				value: ''
			}
		},
		methods: {
			//删除发布的帖子
			toDelete(){
				this.$emit('toDelete', {
					postId: this.item.id
				})
			},
			//跳转到帖子详情
			toDetail(){
				if(this.item.postStatus==1){
					this.$router.push({
						path: '/detail?id='+this.item.id+'&type=' + this.item.categoryScene
					})
				}
			},
			toModify(){
				this.$router.push({
					path: '/publicIndex?type='+this.activeTab+'&id='+this.item.id+'&mode=edit'
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.list{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 20px 0;
		border-bottom: 1px solid var(--color-border);
		.list-l{
			width: 180px;
			height: 100px;
			background: #f5f5f5;
			margin-right:15px;
			img{
				width: 100%;
				height: 100%;
			}
		}
		.list-m{
			width:0;
			flex: 1;
			min-width: 0;
			overflow: hidden;
			.list-title{
				margin-top: 5px;
				font-weight: bold;
				font-size: 18px;
				line-height: 27px;
				width: 100%;
			}
			.list-tips{
				padding: 6px 0 12px;
			}
			.list-btns a{
				display: inline-block;
				min-width: 94px;
				height: 28px;
				border-radius: 4px;
				text-align: left;
				line-height: 28px;
				color: #fff;
				&.passed{
					color: var(--color-status-passed);
				}
				&.passing{
					color: var(--color-status-passing);
				}
				&.no-pass{
					color: var(--color-status-no-pass);
				}
			}
		}
		.list-r{
			width: 140px;
			display: flex;
			justify-content: flex-end;
			gap: 16px;
			.delete-btn{
				display: inline-flex;
				align-items: center;
				white-space: nowrap;
				color: var(--color-text-a);
				cursor: pointer;
				i{
					font-size: 14px;
					line-height: 1;
				}
				span{
					line-height: 1;
				}
			}
		}
	}
</style>
